

























































































































































import {Component} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {ScrollButton, LongTextWings} from 'wings-ui-components';
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import {AddressBookContactItem} from "@/store/addressbooks/types";
import ImportContacts from "@/components/AddressBooks/ImportContacts.vue";
import AddressBookContactsFilter from "@/components/AddressBooks/AddressBookContactsFilter.vue";
import AddressBookContactActions from "@/components/AddressBooks/AddressBookContactActions.vue";
import {notifyDelete, notifyError, notifySuccess} from "@/utils/notify-helper";
import { getTranslatedParams } from '@/utils/notify-utils';
import { ActionLog } from '@/store/auth/types';

@Component({components: {AddressBookContactsFilter, AddressBookContactActions, ImportContacts, LongTextWings, ScrollButton}})
export default class AddressBookContacts extends BaseItemsPage<AddressBookContactItem>{
  @Getter("addressBookContacts") addressBookContactsResponse: any;
  @Getter("addressBookItem") addressBookItem: any;
  @Action("getAddressBookContacts") actionGetAddressBookContacts: any;
  @Action("exportAddressBookContacts") actionExport: any;
  @Action("deleteAddressBookContacts") actionDelete: any;
  @Action("checkAddressBookContacts") actionCheck: any;
  @Action("actionLog") actionLog: any;

  logObject: ActionLog = {}
  private is_show_filter = false;
  private is_show_import = false;
  private is_show_actions = false;
  private recipientIds:(number|undefined)[] = [];
  currentSort = "id";
  currentSortOrder = "desc";
  tableFields = ['id', 'msisdn', 'email', 'name', 'surname', 'middlename', 'additional'];

  getData(): any {
    return this.addressBookContactsResponse;
  }

  additionalFields(item: any) {
    let arr = []
    for (var i = 1; i <= 6; i++) {
      if (item['field'+i]) {
        arr.push(`№${i}: ` + item['field'+i])
      }
    }
    return arr.join('; ')
  }

  back(): void{
    this.$router.push('/address_book/group');
  }

  async exportContacts() {
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Export",
        actionStatus: 'success',
        objectType: "Contact",
        addititionalInfo: getTranslatedParams({groupId: this.addressBookItem?.name})
      }
      await this.actionExport(this.$route.params.id)
      await this.actionLog(this.logObject)
    } catch(error) {
      notifyError(error);
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }

  async checkContacts() {
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Verifying",
        actionStatus: 'success',
        objectType: "Contact",
        addititionalInfo: getTranslatedParams({groupId: this.addressBookItem?.name})
      }
      const data = await this.actionCheck(this.$route.params.id)
      notifySuccess()
      await this.actionLog(this.logObject)

    } catch(error) {
      notifyError(error);
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }

  onSelect(items:AddressBookContactItem[]):void {
    this.recipientIds = items.filter(i => i.id).map(i => i.id)
  }

  onRefresh() {
    // @ts-ignore
    this.$refs.filter.filtered()
  }
}
